import {Action} from "../../../action/action";
import type DetailsState from "..";
import {Booking, Validators} from "@raskrask-dk/raskrask-utils";

export const SET_KLIPPE_CARD = "SET_KLIPPE_CARD";

export class SetKlippeCard extends Action<typeof SET_KLIPPE_CARD, string> {
  readonly type = SET_KLIPPE_CARD;
  protected state: DetailsState;

  constructor(state: DetailsState, klippeCardCode?: string | undefined) {
    super(state, klippeCardCode);
    this.state = state;
  }
  /**
   * Business Logic:
   * We will not allow our customers to pay for their Product with a package/klippecard if the product,
   * is of types Package and OnDemand.
   *
   * @returns
   */
  public isDoable(): boolean {
    const {product, customerType} = this.state;
    const isProductABooking = product instanceof Booking;
    const isCustomerPrivate = customerType === "Private";

    return isProductABooking && isCustomerPrivate;
  }
  public isValid(): boolean {
    const klippeKortCode = this.state.klippeCardCode;
    const isValidCode = klippeKortCode !== undefined && Validators.giftCardCodeValidator(klippeKortCode, "RaskRask"); //
    return this.isDoable() && isValidCode;
  }
}
